<template>
    <div class="cat-picker">
        <skeleton-loader v-if="loading" type="circles" :count="5" />
        <div v-else class="cat-row">
            <button-tooltip v-for="cat in items" :key="cat.id" top :tooltip="categoryLabel(cat.name)">
                <template v-slot:activator="{ on, attrs }">
                    <button type="button" class="cat-btn" :class="{ on: isActive(cat) }" v-bind="attrs" v-on="on"
                        @click="$emit('change', cat)">
                        <v-icon size="22">{{ cat.icon }}</v-icon>
                    </button>
                </template>
            </button-tooltip>
        </div>
    </div>
</template>

<script>
import SkeletonLoader from "@/components/common/SkeletonLoader";
import ButtonTooltip from "@/components/common/ButtonTooltip";

export default {
    name: "CategoryIconPicker",
    components: { SkeletonLoader, ButtonTooltip },
    props: {
        items: {
            type: Array,
            default: () => [],
        },
        value: {
            type: Object,
            default: null,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        isActive(cat) {
            return this.value?.name === cat?.name
        },
    },
}
</script>

<style scoped>
.cat-row {
    display: flex;
    gap: 10px;
    justify-content: center;
    flex-wrap: wrap;
}

.cat-btn {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    border: 2px solid var(--v-outline-base);
    background: var(--v-surface2-base);
    color: var(--v-txtMuted-base);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all .15s;
    flex-shrink: 0;
}

.cat-btn:hover {
    border-color: var(--v-accent-base);
    color: var(--v-accent-base);
}

.cat-btn.on {
    border-color: var(--v-accent-base);
    background: rgba(51, 153, 153, .15);
    color: var(--v-accent-base);
}

.cat-btn .v-icon {
    color: inherit !important;
}
</style>
